export default {
	"name": "ContentSquare",
	"stage": "integration",
	"mandanten": ["2", "2004"],
	"pagetypes": "all",
	"samplingCookie": {
		"name": "ab_bucket",
		"maxValue": 5
	},
	"serviceSettings": {
		"scriptUrl": "//t.contentsquare.net/uxa/699f7fe6ffe1f.js"
	}
}
